import { render, staticRenderFns } from "./FCellAbbrevation.vue?vue&type=template&id=ce58148e&"
import script from "./FCellAbbrevation.vue?vue&type=script&lang=ts&"
export * from "./FCellAbbrevation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports